/* Lycos Vounó: mensaje de regalo en postal escrita a mano */
(function () {
  if (window.__lvPostal) return;
  window.__lvPostal = true;
  var K = { para: 'Postal · Para', msg: 'Postal · Mensaje', de: 'Postal · De' };
  var LIM = { para: 50, msg: 264, de: 60 };
  var DEFAULT = 'Que nuestros aromas te transporten a tu lugar de ensueño…';
  var state = { para: '', msg: '', de: '' };

  var SELLO =
    '<svg viewBox="0 0 250 170" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<defs><path id="lvA" d="M44,82 a56,56 0 0,1 112,0"/><path id="lvB" d="M34,82 a66,66 0 0,0 132,0"/></defs>' +
    '<g fill="none" stroke="#141414"><circle cx="100" cy="82" r="76" stroke-width="1.6"/><circle cx="100" cy="82" r="71" stroke-width=".8"/></g>' +
    '<text font-family="Cormorant, Georgia, serif" font-size="15" letter-spacing="4" fill="#141414"><textPath href="#lvA" startOffset="50%" text-anchor="middle">ATELIER</textPath></text>' +
    '<text font-family="Cormorant, Georgia, serif" font-size="13" letter-spacing="3.5" fill="#141414"><textPath href="#lvB" startOffset="50%" text-anchor="middle">SANTIAGO</textPath></text>' +
    '<text x="100" y="102" text-anchor="middle" font-family="Cormorant, Georgia, serif" font-style="italic" font-size="58" fill="#141414">N</text>' +
    '<circle cx="64" cy="84" r="2.3" fill="#141414"/><circle cx="136" cy="84" r="2.3" fill="#141414"/>' +
    '<g fill="none" stroke="#141414" stroke-width="1.2" stroke-dasharray="5 3">' +
    '<path d="M160,118 q11,-7 22,0 t22,0 t22,0 t22,0"/><path d="M156,130 q11,-7 22,0 t22,0 t22,0 t22,0"/><path d="M160,142 q11,-7 22,0 t22,0 t22,0 t22,0"/><path d="M164,154 q11,-7 22,0 t22,0 t22,0"/></g></svg>';
  var GIFT =
    '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><rect x="3" y="7.5" width="14" height="3" vector-effect="non-scaling-stroke"/><path d="M4.2 10.5v6.5h11.6v-6.5M10 7.5v9.5M10 7.5C8.7 5 6 4 5.4 5.6 4.9 7 7.4 7.5 10 7.5Zm0 0c1.3-2.5 4-3.5 4.6-1.9.5 1.4-2 1.9-4.6 1.9Z" vector-effect="non-scaling-stroke"/></svg>';

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var a = c.attributes || {};
        state = { para: a[K.para] || '', msg: a[K.msg] || '', de: a[K.de] || '' };
        return c;
      });
  }

  function rowHTML() {
    var has = !!state.msg;
    return '<button type="button" class="lv-postal-row__btn" data-lv-postal-open>' +
      '<span class="lv-postal-row__icon">' + GIFT + '</span>' +
      '<span class="lv-postal-row__txt"><span class="lv-postal-row__t">Mensaje de regalo</span>' +
      '<span class="lv-postal-row__s">' + (has ? 'Postal' + (state.para ? ' para ' + esc(state.para) : '') + ' · editar' : 'Lo escribimos a mano en una postal sellada con lacre') + '</span></span>' +
      '<span class="lv-postal-row__plus" aria-hidden="true">' + (has ? '✓' : '+') + '</span></button>';
  }

  function mountRow() {
    var foot = document.querySelector('cart-drawer .drawer__footer');
    if (!foot) return;
    var row = foot.querySelector('.lv-postal-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'lv-postal-row';
      foot.insertBefore(row, foot.firstChild);
    }
    row.innerHTML = rowHTML();
  }

  function modal() {
    var m = document.getElementById('lv-postal-modal');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'lv-postal-modal';
    m.className = 'lv-postal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-labelledby', 'lv-postal-title');
    m.innerHTML =
      '<div class="lv-postal__overlay" data-lv-postal-close></div>' +
      '<div class="lv-postal__panel">' +
      '<div class="lv-postal__preview"><div class="lv-card">' +
      '<div class="lv-card__left"><span class="lv-card__label">Remitente</span>' +
      '<div class="lv-card__msg" data-f="msg"></div><div class="lv-card__de" data-f="de"></div>' +
      '<div class="lv-card__sender"><span>Lycos Vounó</span><small>Home Fragrances Atelier</small><small>lycosvouno.cl</small></div></div>' +
      '<div class="lv-card__right"><div class="lv-card__sello">' + SELLO + '</div>' +
      '<span class="lv-card__label">Destinatario</span>' +
      '<div class="lv-card__lines"><span data-f="para"></span><i></i><i></i><i class="short"></i></div>' +
      '<em class="lv-card__claim">Una fragancia. Un destino.</em></div>' +
      '</div><p class="lv-postal__nota">Vista previa. Tu mensaje se escribe a mano y la postal se sella con lacre.</p></div>' +
      '<form class="lv-postal__form" novalidate>' +
      '<button type="button" class="lv-postal__x" aria-label="Cerrar" data-lv-postal-close>×</button>' +
      '<p class="lv-postal__kicker">Sin costo</p>' +
      '<h2 class="lv-postal__title" id="lv-postal-title">Mensaje de regalo</h2>' +
      '<p class="lv-postal__intro">Añade un toque personal. Lo escribimos a mano en una postal de la casa.</p>' +
      field('para', 'Para', false, 'input') + field('msg', 'Mensaje', true, 'textarea') + field('de', 'De', false, 'input') +
      '<p class="lv-postal__err" hidden>Escribe un mensaje para guardar la postal.</p>' +
      '<div class="lv-postal__actions"><button type="button" class="lv-postal__btn lv-postal__btn--ghost" data-lv-postal-close>Cancelar</button>' +
      '<button type="submit" class="lv-postal__btn">Guardar</button></div>' +
      '<button type="button" class="lv-postal__remove" data-lv-postal-remove hidden>Quitar mensaje</button>' +
      '</form></div>';
    document.body.appendChild(m);

    m.addEventListener('input', function (e) {
      var k = e.target.getAttribute('data-k');
      if (!k) return;
      if (e.target.value.length > LIM[k]) e.target.value = e.target.value.slice(0, LIM[k]);
      paint();
    });
    m.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = values();
      if (!v.msg.trim()) { m.querySelector('.lv-postal__err').hidden = false; return; }
      save(v);
    });
    return m;
  }

  function field(k, label, req, tag) {
    var id = 'lv-postal-' + k;
    var ctl = tag === 'textarea'
      ? '<textarea id="' + id + '" data-k="' + k + '" rows="4" maxlength="' + LIM[k] + '"' + (req ? ' required' : '') + '></textarea>'
      : '<input id="' + id + '" data-k="' + k + '" type="text" maxlength="' + LIM[k] + '" autocomplete="off">';
    return '<div class="lv-postal__field"><div class="lv-postal__lbl"><label for="' + id + '">' + label + (req ? ' <span aria-hidden="true">*</span>' : '') + '</label>' +
      '<span class="lv-postal__count" data-c="' + k + '">0/' + LIM[k] + '</span></div>' + ctl + '</div>';
  }

  function values() {
    var m = modal(), o = {};
    ['para', 'msg', 'de'].forEach(function (k) { o[k] = m.querySelector('[data-k="' + k + '"]').value; });
    return o;
  }

  function paint() {
    var m = modal(), v = values();
    ['para', 'msg', 'de'].forEach(function (k) { m.querySelector('[data-c="' + k + '"]').textContent = v[k].length + '/' + LIM[k]; });
    var msgEl = m.querySelector('[data-f="msg"]');
    var t = v.msg.trim();
    msgEl.textContent = t || DEFAULT;
    msgEl.classList.toggle('is-default', !t);
    var n = (t || DEFAULT).length;
    msgEl.style.fontSize = (n < 50 ? 4.6 : n < 100 ? 3.7 : n < 170 ? 3 : 2.5) + 'cqw';
    m.querySelector('[data-f="de"]').textContent = v.de.trim() ? '— ' + v.de.trim() : '';
    m.querySelector('[data-f="para"]').textContent = v.para.trim();
    m.querySelector('.lv-postal__err').hidden = true;
  }

  function open() {
    var m = modal();
    load().then(function () {
      m.querySelector('[data-k="para"]').value = state.para;
      m.querySelector('[data-k="msg"]').value = state.msg;
      m.querySelector('[data-k="de"]').value = state.de;
      m.querySelector('[data-lv-postal-remove]').hidden = !state.msg;
      paint();
      m.classList.add('is-open');
      document.documentElement.classList.add('lv-postal-lock');
      setTimeout(function () { m.querySelector('[data-k="para"]').focus(); }, 50);
    });
  }

  function close() {
    var m = document.getElementById('lv-postal-modal');
    if (m) m.classList.remove('is-open');
    document.documentElement.classList.remove('lv-postal-lock');
  }

  function save(v) {
    var attrs = {};
    attrs[K.para] = v.para.trim();
    attrs[K.msg] = v.msg.trim();
    attrs[K.de] = v.de.trim();
    var btn = modal().querySelector('button[type="submit"]');
    btn.disabled = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { return r.json(); })
      .then(function () { state = { para: attrs[K.para], msg: attrs[K.msg], de: attrs[K.de] }; mountRow(); close(); })
      .finally(function () { btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lv-postal-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-lv-postal-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-lv-postal-remove]')) { e.preventDefault(); save({ para: '', msg: '', de: '' }); }
  });
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var f = document.querySelector('cart-drawer .drawer__footer');
        if (f && !f.querySelector('.lv-postal-row')) mountRow();
      }, 60);
    }).observe(drawer, { childList: true, subtree: true });
    load().then(mountRow);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
